<div
  class="customer-name h3-bold cursor-pointer"
  *ngIf="Type === 'customer'"
  (click)="onClick.emit({ action: 'customer-detail', value: data })">
  <app-avatar-icon seed="{{ data[Type]['name'] }}" [size]="32"></app-avatar-icon
  >{{ data[Type]['name'] }}
</div>
<!-- <span class="icon">😎</span> -->
<div class="customers position-relative primary-100" *ngIf="Type === 'customers'">
  <div class="avatar-group">
    <div class="ce-avtar" *ngFor="let customer of data[Type].users.slice(0, 4); let i = index">
      <img
        class="ce-img"
        [matTooltip]="customer.name"
        [matTooltipPosition]="'above'"
        src="{{ customer.image }}"
        alt="" />
    </div>
    <div
      class="hidden-avatar h5-bold"
      *ngIf="data[Type].users.length > 4"
      [cdkMenuTriggerFor]="menu"
      cdkConnectedOverlayOrigin>
      +{{ data[Type].users.length - 4 }}
    </div>
  </div>
  <ng-template #menu>
    <div class="bottom-margin" cdkMenu>
      <div class="custom-dropdown customer-dropdown radius-4 radius-top-left">
        <div
          *ngIf="data[Type].users.length > 9"
          class="w-100"
          app-search
          [active]="false"
          [SearchBtn]="false"
          [disabled]="false"
          size="medium"
          (onSearch)="onSearch($event)"></div>
        <ng-container *ngFor="let list of data[Type].users.slice(4)">
          <dropdown-single-piece
            class="w-100"
            [label]="list.name"
            [color]="'default'"
            [type]="'reg'"
            [state]="'default'"
            [image]="list.image"
            [showUser]="true"
            [icon]="false"
            [iconType]="'balance'"
            [dragDrop]="false"
            [toggle]="false"
            [more]="true"
            [radio]="false"
            [checkbox]="false"
            cdkMenuItem
            (customClick)="customClick(list)"></dropdown-single-piece>
        </ng-container>
      </div>
    </div>
  </ng-template>
</div>

<div
  class="cust-order primary-100 cursor-pointer"
  *ngIf="Type === 'orders'"
  (click)="onClick.emit({ event: 'order', value: data[Type]['number'] })">
  <app-badges
    *ngIf="data[Type]['badge_label']"
    [withIcon]="true"
    Type="{{ data[Type]['badge_type'] }}"
    IconType="{{ data[Type]['badge_icon'] }}"
    label="{{ data[Type]['badge_label'] }}"
    [ellipsis]="true"></app-badges>
  <div class="order">
    <span class="order-id h3-bold">{{ data[Type]['number'] }}</span>
    <span class="store" *ngIf="data[Type]['storeIcons']">
      <app-ce-icon
        name="{{ data[Type]['storeIcons'] }}"
        [svg_class]="['primary-100']"></app-ce-icon>
    </span>
  </div>
</div>

<div class="cust-order primary-100" *ngIf="Type === 'payments'" (click)="onClick.emit($event)">
  <app-badges [withIcon]="true" IconType="dot" Type="completed" label="Paid"></app-badges>
  <div class="order">
    <a href="#" class="order-id h3-bold">48801525</a>
  </div>
</div>

<div class="star-rating primary-100" *ngIf="Type === 'rating'">
  <ng-container *ngFor="let star of stars; index as i">
    <app-ce-icon
      [name]="'staricon'"
      class="rating"
      [class.unrating]="i >= data[Type]['currentRate']"
      (click)="!data[Type]['readonly'] ? rate(i + 1) : null">
    </app-ce-icon>
  </ng-container>
</div>

<div class="progress-data d-flex flex-column spacing-8" *ngIf="Type === 'progressBar'">
  <h1 class="h4-bold primary-100">{{ data[Type]['title'] }}</h1>
  <mat-progress-bar
    mode="determinate"
    value="{{ data[Type]['value'] }}"
    [ngClass]="data[Type]['progressColor']"></mat-progress-bar>
</div>

<div class="tier-data d-flex align-items-center spacing-8" *ngIf="Type === 'tier'">
  <app-icon-container
    [Type]="'icon'"
    [Size]="'medium'"
    [IconType]="data[Type]['icon']"
    [background_color]="'info-120'"></app-icon-container>
  <h1 class="h4-bold primary-100">{{ data[Type]['title'] }}</h1>
</div>

<div class="status-date d-flex flex-column spacing-8" *ngIf="Type === 'statusDate'">
  <div class="d-flex align-items-center spacing-8 h3-reg primary-100">
    <app-badges
      (click)="isStatus = !isStatus"
      cdkOverlayOrigin
      #trigger="cdkOverlayOrigin"
      cdkConnectedOverlayPanelClass="example-panel"
      class="cursor-pointer"
      [withIcon]="true"
      Type="{{ data[Type]['status']['statusType'] }}"
      IconType="{{ data[Type]['status']['IconType'] }}"
      label="{{ data[Type]['status']['label'] }}"
      [ellipsis]="true"></app-badges>
    <ng-template
      cdkConnectedOverlay
      cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
      [cdkConnectedOverlayHasBackdrop]="true"
      (detach)="isStatus = false"
      (backdropClick)="isStatus = false"
      [cdkConnectedOverlayOrigin]="trigger"
      [cdkConnectedOverlayOpen]="isStatus"
      [cdkConnectedOverlayPositions]="[
        {
          originX: 'start',
          originY: 'bottom',
          overlayX: 'start',
          overlayY: 'top',
        },
        {
          originX: 'end',
          originY: 'top',
          overlayX: 'end',
          overlayY: 'bottom',
        },
      ]"
      [cdkConnectedOverlayFlexibleDimensions]="true">
      <div class="custom-dropdown slo-overlay mt-2">
        <div class="m-0 p-0 d-flex align-items-start flex-column spacing-8 w-100">
          <div
            *ngFor="let slo of data[Type]['sloStatus']"
            class="d-flex align-items-center justify-content-between w-100 primary-100">
            {{ slo.label }}
            <app-badges
              [withIcon]="false"
              Type="white"
              IconType="no_icon"
              [label]="slo.date"
              [ellipsis]="true"></app-badges>
          </div>
        </div>
      </div>
    </ng-template>
  </div>
  @if (data[Type]['date']) {
    <div class="d-flex align-items-center spacing-8 h3-reg primary-100">
      <app-ce-icon [name]="'clock'" [svg_class]="['primary-50']"></app-ce-icon>
      {{ data[Type]['date'] }}
    </div>
  }
</div>

<div
  class="cust-order primary-100 flex-column align-items-start justify-content-start spacing-2"
  *ngIf="Type === 'settlement'"
  (click)="onClick.emit($event)">
  <div class="d-flex align-items-start h4-bold">
    {{ data[Type]['order_price'] }}
    <span class="h4-reg primary-60">{{ data[Type]['settle_price'] }}</span>
  </div>
  <app-badges
    [withIcon]="true"
    Type="{{ data[Type]['Type'] }}"
    IconType="{{ data[Type]['IconType'] }}"
    label="{{ data[Type]['label'] }}"
    [ellipsis]="true"></app-badges>
</div>

<div class="button primary-100" *ngIf="Type === 'button'">
  <app-secondary-btns
    [active]="false"
    [disabled]="false"
    label="{{ data[Type]['button_label'] }}"
    size="medium"
    Type="withoutIcon"
    IconValue=""
    (onClick)="onClick.emit({ event: 'button', value: data })"></app-secondary-btns>
</div>

<div class="segment primary-100" *ngIf="Type === 'segments'">
  <!-- Show first 5 segments by default -->
  <app-badges
    *ngFor="let segment of data[Type]?.slice(0, displayedSegmentsLimit); let i = index"
    IconType="{{ segment.icon }}"
    [codeView]="segment.codeView"
    [withIcon]="false"
    [uppercase]="segment.uppercase"
    Type="tag"
    label="{{ segment.segmentName }}"
    [ellipsis]="true">
  </app-badges>

  <!-- Show the + button if there are more than 5 segments -->
  <app-badges
    *ngIf="data[Type]?.length > displayedSegmentsLimit"
    [withIcon]="false"
    class="cursor-pointer"
    Type="tag"
    [label]="'+' + (data[Type]?.length - displayedSegmentsLimit)"
    (click)="onStatus()"
    cdkOverlayOrigin
    #trigger="cdkOverlayOrigin"
    cdkConnectedOverlayPanelClass="example-panel">
  </app-badges>

  <!-- Dropdown to show all segments when the + is clicked -->
  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOpen]="isOpen"
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayPositions]="[
      { originX: 'start', originY: 'bottom', overlayX: 'start', overlayY: 'top' },
      { originX: 'end', originY: 'top', overlayX: 'end', overlayY: 'bottom' },
    ]">
    <div class="custom-dropdown border-radius">
      <div class="cursor-pointer" *ngFor="let segment of data[Type]">
        <div class="d-flex spacing-8 align-items-center">
          <app-badges
            IconType="{{ segment.icon }}"
            [codeView]="segment.codeView"
            [withIcon]="false"
            Type="tag"
            label="{{ segment.segmentName }}"
            [ellipsis]="true">
          </app-badges>
        </div>
      </div>
    </div>
  </ng-template>
</div>

<div class="icons primary-100 d-flex align-items-center spacing-4" *ngIf="Type === 'channel'">
  <app-icon-btn
    *ngFor="let icon of data[Type]; let i = index"
    [active]="icon.active"
    [size]="'medium'"
    iconType="{{ icon.icon }}"></app-icon-btn>

  <app-badges
    [withIcon]="false"
    class="cursor-pointer"
    Type="tag"
    [label]="'+' + data[Type]?.length?.toString()"
    (click)="onStatus()"
    cdkOverlayOrigin
    #trigger="cdkOverlayOrigin"
    cdkConnectedOverlayPanelClass="example-panel"></app-badges>

  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOpen]="isOpen"
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayPositions]="[
      {
        originX: 'start',
        originY: 'bottom',
        overlayX: 'start',
        overlayY: 'top',
      },
      {
        originX: 'end',
        originY: 'top',
        overlayX: 'end',
        overlayY: 'bottom',
      },
    ]">
    <div class="custom-dropdown border-radius">
      <div class="single-piece cursor-pointer" *ngFor="let icon of data[Type]">
        <div class="d-flex spacing-8 align-items-center">
          <app-icon-btn
            [active]="icon.active"
            [size]="'medium'"
            iconType="{{ icon.icon }}"></app-icon-btn>
          {{ icon.channelName }}
        </div>
      </div>
    </div>
  </ng-template>
</div>

<div
  *ngIf="Type === 'campaign'"
  class="campaign-data primary-100"
  (click)="onClick.emit({ event: 'campaign', value: 'id' })">
  <h3 class="h3-bold cursor-pointer">{{ data[Type]['campaign_name'] }}</h3>
  <p class="h4-reg campaign-text">{{ data[Type]['description'] }}</p>
</div>

<div *ngIf="Type === 'empty'" class="campaign-data primary-100"></div>

<app-toggle
  *ngIf="Type === 'toggle'"
  (onCheckChange)="onChange.emit($event)"
  [active]="data[Type]['active']"
  [disabled]="data[Type]['disabled']"
  [size]="'large'"></app-toggle>

@if (Type === 'avataar') {
  <app-avatar-icon seed="{{ data[Type]['seed'] }}" [size]="data[Type]['size']"></app-avatar-icon>
}

<app-input-wrapper
  *ngIf="Type === 'input'"
  [type]="Type"
  [data]="data"
  (onChange)="onChange.emit($event)"></app-input-wrapper>
<app-badges
  [class.cursor-pointer]="data[Type]['copymode']"
  *ngIf="Type === 'status'"
  [withIcon]="true"
  Type="{{ data[Type]['Type'] }}"
  [uppercase]="data[Type]['uppercase']"
  [codeView]="data[Type]['codeView']"
  [lowerCase]="data[Type]['lowercase']"
  IconType="{{ data[Type]['IconType'] }}"
  label="{{ data[Type]['label'] }}"
  [ellipsis]="false"
  [cdkCopyToClipboard]="data[Type]['copymode'] ? data[Type]['label'] : null"
  (click)="copy(data[Type]['copymode'])"
  #tooltip="matTooltip"
  (mouseenter)="$event.stopImmediatePropagation()"
  (mouseleave)="$event.stopImmediatePropagation()"
  [matTooltip]="'Id Copied'"
  [matTooltipPosition]="'above'"
  [cdkCopyToClipboard]="data[Type]['copymode'] ? data[Type]['label'] : null"
  (click)="onStatus()"></app-badges>
<!-- <ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOpen]="isOpen"
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayPositions]="[
    {
      originX: 'start',
      originY: 'bottom',
      overlayX: 'start',
      overlayY: 'top',
    },
    {
      originX: 'end',
      originY: 'top',
      overlayX: 'end',
      overlayY: 'bottom',
    },
  ]">
  @if (data[Type]['copymode']) {
    <div class="custom-tooltip">
      <app-tooltip label="Copied" Type="default" size="medium"></app-tooltip>
    </div>
  }
</ng-template> -->

<div class="div" *ngIf="Type === 'shipmentStatus'">
  <app-badges
    [withIcon]="true"
    Type="{{ data[Type]['Type'] }}"
    IconType="{{ data[Type]['IconType'] }}"
    label="{{ data[Type]['label'] }}"
    [ellipsis]="true"
    (click)="onStatus()"
    cdkOverlayOrigin
    #trigger1="cdkOverlayOrigin"
    cdkConnectedOverlayPanelClass="example-panel"
    class="cursor-pointer"></app-badges>
  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOpen]="isOpen"
    [cdkConnectedOverlayOrigin]="trigger1"
    [cdkConnectedOverlayPositions]="[
      {
        originX: 'start',
        originY: 'bottom',
        overlayX: 'start',
        overlayY: 'top',
      },
      {
        originX: 'end',
        originY: 'top',
        overlayX: 'end',
        overlayY: 'bottom',
      },
    ]">
    <div class="custom-dropdown slo-overlay mt-2">
      <div class="m-0 p-0 d-flex align-items-start flex-column spacing-8 w-100">
        <app-shipping-tooltip
          [type]="'delivered'"
          [shippingHeading]="{
            status: { status_type: 'white', track: '1 Day late' },
          }"
          [shipping]="data[Type]['shipping']"></app-shipping-tooltip>
      </div>
    </div>
  </ng-template>
</div>
<div class="div" *ngIf="Type === 'attribute'">
  <div class="attribute-data d-flex align-items-center spacing-12">
    <app-datatypes
      [label]="'database'"
      [size]="'large'"
      [Type]="data[Type]['dataType']"></app-datatypes>
    <div class="title h3-bold primary-100">{{ data[Type]['title'] }}</div>
  </div>
</div>

<div class="div" *ngIf="Type === 'shipmentStock'">
  <app-badges
    [withIcon]="true"
    Type="{{ data[Type]['Type'] }}"
    IconType="{{ data[Type]['IconType'] }}"
    label="{{ data[Type]['label'] }}"
    [ellipsis]="true"
    (click)="onStock()"
    cdkOverlayOrigin
    #trigger="cdkOverlayOrigin"
    cdkConnectedOverlayPanelClass="example-panel"
    class="cursor-pointer"></app-badges>
  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOpen]="isOpen"
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayPositions]="[
      {
        originX: 'start',
        originY: 'bottom',
        overlayX: 'start',
        overlayY: 'top',
      },
      {
        originX: 'end',
        originY: 'top',
        overlayX: 'end',
        overlayY: 'bottom',
      },
    ]">
    <div class="custom-dropdown slo-overlay mt-2">
      <div class="m-0 p-0 d-flex align-items-start flex-column spacing-8 w-100">
        <div class="d-flex align-items-center justify-content-between h4-reg w-100 primary-60">
          <span>Location</span>
          <span>Stock availability</span>
        </div>
        <div class="border-line"></div>
        <div
          *ngFor="let item of data[Type]['stock']"
          class="d-flex align-items-center justify-content-between w-100 primary-100">
          <div class="d-flex align-items-center spacing-4">
            <app-ce-icon [name]="'warehouse'" [svg_class]="['primary-50']"></app-ce-icon
            >{{ item.label }}
          </div>
          <app-badges
            [withIcon]="false"
            [Type]="item.type"
            [IconType]="item.icon"
            [label]="item.date"
            [ellipsis]="true"></app-badges>
        </div>
      </div>
    </div>
  </ng-template>
</div>

<div
  class="product cursor-pointer"
  *ngIf="Type === 'product'"
  (click)="onClick.emit({ action: 'product-detail', value: data })">
  <div class="media d-flex align-items-center spacing-16">
    <img
      alt="product image"
      class="product-img"
      src="{{ data[Type]['product_img'] || '/assets/No-Image-Placeholder.svg' }}" />
    <div class="product-detail d-flex align-items-start spacing-4 flex-column">
      <h2
        class="h3-bold m-0 p-0"
        [class.red]="data[Type]['color'] === 'red'"
        [class.strike]="data[Type]['strike'] === 'strike'">
        {{ data[Type]['product_name'] }}
      </h2>
    </div>
    <app-badges
      *ngIf="data[Type]['status']"
      [withIcon]="true"
      Type="{{ data[Type]['status']['status_type'] }}"
      IconType="{{ data[Type]['status']['IconType'] }}"
      label="{{ data[Type]['status']['label'] }}"
      [ellipsis]="true"></app-badges>
  </div>
</div>

<div class="product primary-100" *ngIf="Type === 'product_details'">
  <div class="media d-flex align-items-center spacing-16">
    <img
      alt="product image"
      class="product-img"
      src="{{ data[Type]['product_img'] || '/assets/No-Image-Placeholder.svg' }}" />
    <div class="product-detail d-flex align-items-start spacing-4 flex-column">
      <h3 class="h3-bold m-0 p-0 primary-100" role="heading" aria-level="3">
        {{ data[Type]['product_name'] }}
      </h3>
      <div class="d-flex align-items-center justify-content-start spacing-8">
        <span role="text" class="h4-reg primary-60" [class.red]="data[Type]['color'] === 'red'">
          {{ data[Type]['price'] }}
        </span>
        <span *ngIf="data[Type]['stock']" aria-hidden="true" class="dot-divder"></span>
        <span role="text" class="h4-reg primary-60">
          {{ data[Type]['stock'] }}
        </span>
        <span *ngIf="data[Type]['active']" aria-hidden="true" class="dot-divder"></span>
        <span role="text" class="h4-reg primary-60">
          {{ data[Type]['active'] }}
        </span>
      </div>
    </div>
  </div>
</div>
<div class="product primary-100" *ngIf="Type === 'order_w_icons'">
  <div class="media d-flex align-items-center spacing-16">
    <app-icon-container
      *ngIf="data[Type]['showIcon']"
      [IconType]="data[Type]['iconContainer']"
      background_color="primary-20"></app-icon-container>
    <div class="product-detail d-flex align-items-start spacing-4 flex-column">
      <h3
        class="h3-bold m-0 p-0 primary-100 d-flex align-items-center spacing-4"
        role="heading"
        aria-level="3">
        {{ data[Type]['product_name'] }}
        <span class="store" *ngIf="data[Type]['showChannel']">
          <app-icon-container
            [IconType]="data[Type]['storeIcons']"
            [Size]="'medium'"
            background_color="primary-20"></app-icon-container>
        </span>
      </h3>
      <div class="d-flex align-items-center justify-content-start spacing-8">
        <span role="text" class="h4-reg primary-60" [class.red]="data[Type]['color'] === 'red'">
          {{ data[Type]['price'] }}
        </span>
        <span *ngIf="data[Type]['stock']" aria-hidden="true" class="dot-divder"></span>
        <span role="text" class="h4-reg primary-60">
          {{ data[Type]['stock'] }}
        </span>
        <span *ngIf="data[Type]['active']" aria-hidden="true" class="dot-divder"></span>
        <span role="text" class="h4-reg primary-60">
          {{ data[Type]['active'] }}
        </span>
      </div>
    </div>
  </div>
</div>

<div
  class="d-flex align-items-center spacing-4"
  *ngIf="Type === 'text'"
  [class.cursor-pointer]="data[Type]['cursor']"
  [class.red]="data[Type]['color'] === 'red'"
  [class.warning]="data[Type]['color'] === 'warning'"
  [class.strike]="data[Type]['strike'] === 'strike'">
  <span
    class="name h3-reg d-flex align-items-center spacing-4"
    [class.primary-100]="!data[Type]['color']">
    <app-ce-icon [name]="data[Type]['icon']" [svg_class]="['primary-50']"></app-ce-icon
    >{{ data[Type]['title'] }}
  </span>
  <app-badges
    *ngIf="data[Type]['status']"
    [withIcon]="false"
    [lowerCase]="data[Type]['status']['lowercase']"
    [uppercase]="data[Type]['status']['uppercase']"
    Type="{{ data[Type]['status']['status_type'] }}"
    IconType="{{ data[Type]['status']['IconType'] }}"
    label="{{ data[Type]['status']['label'] }}"
    [ellipsis]="true"></app-badges>
</div>

<div
  *ngIf="Type === 'left_icon'"
  [class.cursor-pointer]="data[Type]['cursor']"
  [class.red]="data[Type]['color'] === 'red'"
  [class.warning]="data[Type]['color'] === 'warning'"
  [class.strike]="data[Type]['strike'] === 'strike'"
  (click)="onClick.emit({ event: 'left_icon', value: data[Type]['title'] })">
  <span
    class="name h3-reg d-flex align-items-center spacing-8"
    [class.primary-100]="!data[Type]['color']">
    <app-ce-icon [name]="data[Type]['icon']" [svg_class]="['primary-50']"></app-ce-icon
    >{{ data[Type]['title'] }}
  </span>
</div>
<div
  *ngIf="Type === 'right_icon'"
  class="cursor-pointer"
  [class.red]="data[Type]['color'] === 'red'"
  [class.warning]="data[Type]['color'] === 'warning'"
  [class.strike]="data[Type]['strike'] === 'strike'"
  (click)="onClick.emit({ event: 'right_icon', value: data[Type]['title'] })">
  <span
    class="name h3-reg d-flex align-items-center spacing-8"
    [class.primary-100]="!data[Type]['color']">
    {{ data[Type]['title'] }}
    <app-ce-icon [name]="data[Type]['icon']" [svg_class]="['primary-50']"></app-ce-icon>
  </span>
</div>

<div
  *ngIf="Type === 'location'"
  [class.cursor-pointer]="data[Type]['cursor']"
  (click)="onClick.emit({ event: 'location', value: 'id' })">
  <span class="name h3-reg d-flex align-items-center spacing-12 primary-100">
    <img alt="location image" class="location-img" src="{{ data[Type]['location_img'] }}" />
    {{ data[Type]['location_name'] }}
  </span>
</div>

<div *ngIf="Type === 'date'">
  <span class="name h3-reg">{{ data[Type]['title'] | date: data[Type]['format'] }}</span>
</div>

<div *ngIf="Type === 'currency'">
  <span class="name h3-reg">{{ data[Type]['title'] | currency: '₹' }}</span>
</div>

<div *ngIf="Type === 'actions'" class="table-control">
  <ng-container *ngFor="let action of data[Type]">
    <app-action-btn
      [active]="action.active"
      [disabled]="action.disabled"
      IconType="{{ action.icon }}"
      (custom_click)="actionClick(action)"
      [cdkMenuTriggerFor]="showDropdown(action) ? menu : null"
      cdkConnectedOverlayOrigin></app-action-btn>
    <ng-template #menu>
      <div class="bottom-margin" cdkMenu>
        <div class="custom-dropdown radius-4 radius-bottom-left">
          <ng-container *ngIf="action.dropdown && action.dropdown.length > 0">
            <ng-container *ngFor="let dropdownItem of action.dropdown">
              <dropdown-single-piece
                class="w-100 cursor-pointer"
                (onAction)="actionClick(dropdownItem, action)"
                [label]="dropdownItem.label"
                [color]="dropdownItem.color"
                [type]="'bold'"
                [icon]="true"
                [iconType]="dropdownItem.icon"
                [dragDrop]="false"
                [toggle]="false"
                [more]="false"
                [radio]="false"
                cdkMenuItem></dropdown-single-piece>
            </ng-container>
          </ng-container>
        </div>
      </div>
    </ng-template>
  </ng-container>
</div>
